<template>
  <v-app id="404">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <AppDrawer v-if="isAuthenticated" />
        <AppBar v-if="isAuthenticated" />
        <div class="mr-3 hidden-sm-and-down">
          <img src="@/infrastructure/vue/assets/img/error/403.svg" alt="" />
        </div>
        <div class="text-md-center">
          <h1>403</h1>
          <h2 class="my-3 headline">Sorry, access denied.</h2>

          <div v-if="!isAuthenticated">
            <v-btn color="primary" @click="goHome">Go Home</v-btn>
          </div>
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import AppBar from '../../components/common/bars/AppBar.vue';
import AppDrawer from '../../components/common/navigations/AppDrawer.vue';

export default {
  name: 'DenyPage',
  computed: {
    ...mapGetters('login', ['isAuthenticated']),
  },
  methods: {
    goHome() {
      this.$router.push({ path: '/' });
    },
  },
  components: { AppBar, AppDrawer },
};
</script>
<style scoped lang="css">
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
